import { Component, Input } from "@angular/core";

import { EventsHubService, ExamMessage, EXAMMESSAGETYPE } from "src/app/services/eventshub.service";
import { PageObjectInput } from "src/app/models/pageobjectinput";

@Component({
  selector: "hkt-pageobjectinput",
  templateUrl: "./pageobjectinput.component.html",
  styleUrls: ["./pageobjectinput.component.scss"],
})
export class PageObjectInputComponent {
  @Input("obj") obj: PageObjectInput;
  @Input("mode") mode: string;

  constructor(private eventsHubService: EventsHubService) {}

  onUpdateText(event): void {
    if (this.mode != "exam") {
      return;
    }
    this.obj.text = event.target.value;

    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "SaveExam()";
    this.eventsHubService.setExamMessage(msg);
  }
}
